export const TestIds = {
  header: 'chat-header',
  closeButton: 'chat-header-close-button',
  titleSection: 'chat-header-title-section',
  historyButton: 'chat-header-history-button',
  newChatButton: 'chat-header-new-chat-button',
};
